import { Skeleton } from "@mui/material";
import { FunctionComponent } from "react";


interface Props {

}

const SkeletonEditEvents: FunctionComponent<Props> = () => {
  return (<>
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </>);
}

export default SkeletonEditEvents;
